import React from 'react';
import { Link } from 'react-router-dom';

function ValueAddition() {
  return (
    <div className="w-full">
      <section id="value" className="w-full bg-white py-16">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="flex flex-col gap-5">
            <h2 className="font-serif text-4xl text-coffee-dark">Value Addition: Elevating Uganda’s Coffee</h2>
            <p className="mt-2 text-sm text-gray-600">
              Our approach integrates farmer training, selective processing, and market-driven roasting to create distinctive Ugandan profiles that stand out globally.
            </p>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <img src="https://api.iconify.design/lucide-check-circle.svg?color=%233F7C3A" alt="Check icon" className="w-5 h-5 mt-0.5"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-dark">Farmer Training & Mafunzo Sessions</span>
                  <span className="mt-2 text-sm text-gray-600">Selective picking, fermentation control, and drying best practices.</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <img src="https://api.iconify.design/lucide-scale.svg?color=%233F7C3A" alt="Scale icon" className="w-5 h-5 mt-0.5"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-dark">Quality Grading & Cupping</span>
                  <span className="mt-2 text-sm text-gray-600">Defect sorting, moisture targets, and sensory evaluation.</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <img src="https://api.iconify.design/lucide-thermometer.svg?color=%233F7C3A" alt="Thermometer icon" className="w-5 h-5 mt-0.5"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-dark">Roast Development</span>
                  <span className="mt-2 text-sm text-gray-600">Profile creation tailored to origin characteristics.</span>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-2">
              <img src="https://api.iconify.design/lucide-info.svg?color=%235C3A21" alt="Info icon" className="w-5 h-5"/>
              <span className="mt-2 text-sm text-gray-600">We publish traceability data with each lot.</span>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22coffee%20drying%22&w=800&h=600" alt="Raised bed drying" className="w-full h-60 object-cover"/>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22coffee%20cherry%22&w=800&h=600" alt="Coffee cherries" className="w-full h-60 object-cover"/>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22coffee%20quality%20control%22&w=800&h=600" alt="Quality control lab" className="w-full h-60 object-cover"/>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22coffee%20roastery%22&w=800&h=600" alt="Roastery equipment" className="w-full h-60 object-cover"/>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ValueAddition;
